// Un projet d'avant les modèles garde ses piliers tant que personne n'a confirmé
// son modèle : ce bandeau le demande, et ouvre l'état des lieux sur cette seule
// question. Enregistrer le marché vaut confirmation.
import { useCallback, useState } from 'react';
import { useProductContext } from '../api/queries';
import { Button, Note } from '../components/ui';
import { Drawer } from '../write/Drawer';
import { useCanWrite } from '../write/useCanWrite';
import { Mesure0Wizard } from './Mesure0Wizard';

export function PillarModelBanner({ projectId, projectName }: { projectId: string; projectName: string }) {
  const context = useProductContext(projectId);
  const canWrite = useCanWrite(projectId);
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);

  if (!context.data || !canWrite || context.data.product.pillarModel) return null;

  return (
    <>
      <Note tone="avertissement">
        <p>
          <strong>Confirmez le modèle de ce produit.</strong> Les piliers d’adoption dépendent désormais
          du modèle B2B, B2C ou B2E. Vos preuves et vos notes sont conservées.
        </p>
        <Button type="button" variant="ghost" onClick={() => setOpen(true)}>
          Confirmer le modèle
        </Button>
      </Note>
      <Drawer open={open} title="État des lieux" onClose={close} wide>
        <Mesure0Wizard
          projectId={projectId}
          projectName={projectName}
          context={context.data}
          only="product"
          onClose={close}
        />
      </Drawer>
    </>
  );
}
